import * as ActionTypes from '../constants/action_types'
import { AUDIENCE_LIMIT } from '../constants/commons'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchAudienceAcquisition (networkEntityId) {
  return utils.makeApiCall({
    url: `/api/audience-acquisition/${networkEntityId}/${AUDIENCE_LIMIT}`,
    actionRequest: ActionTypes.REQUEST_AUDIENCE_ACQUISITION,
    actionReceive: ActionTypes.RECEIVE_AUDIENCE_ACQUISITION,
    actionFailure: ActionTypes.REQUEST_AUDIENCE_ACQUISITION_FAILURE,
    authenticated: true,
    actionProps: {
      networkEntityId: networkEntityId
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchAudienceAcquisitionIfNeeded (networkEntityId) {
  return (dispatch, getState) => {
    const state = (getState().audienceAcquisition.byId[networkEntityId] || {}).audienceAcquisition
    if (utils.shouldFetch(state)) {
      return dispatch(fetchAudienceAcquisition(networkEntityId))
    }
    return Promise.resolve()
  }
}